import { Formik } from 'formik';
import React from 'react'
import LoginDTO from '../../../Models/LoginDTO';
import { useStore } from '../../../Stores/store';

const inputClass = "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500";
const labelClass = "text-sm font-medium text-gray-700";

export default function LogInForm(){
    const { managementStore } = useStore();
    const { login } = managementStore;

    const formVals : LoginDTO = {
        email : "",
        password: ""
    }

    const handleSubmit = (values : any) => {
        login(values);
    }

    return (
        <div className="w-full">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Login</h2>
            <Formik
                initialValues={formVals}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
            >
                {({handleSubmit, handleChange, values}) => (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div className="flex flex-col gap-1">
                            <label htmlFor="email" className={labelClass}>Email</label>
                            <input type="text" name="email" id="email" value={values.email} onChange={handleChange} className={inputClass} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="password" className={labelClass}>Password</label>
                            <input type="password" id="password" name="password" value={values.password} onChange={handleChange} className={inputClass} />
                        </div>
                        <button type="submit" className="w-full mt-2 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm font-medium cursor-pointer">
                            Login
                        </button>
                    </form>
                )}
            </Formik>
        </div>
    );
}